module.exports = __webpack_public_path__ + "static/media/sneakpeek-message-icon.42112233.png";